import { useInvoiceKpis } from '@/hooks/useInvoices';
import { Skeleton } from '@/components/ui/skeleton';
import { formatMoney } from './invoice-shared';

interface StatCard {
  label: string;
  dot: string;
  value: (v: NonNullable<ReturnType<typeof useInvoiceKpis>['data']>) => string;
}

const CARDS: StatCard[] = [
  { label: 'DUE TODAY', dot: 'bg-warning', value: (k) => formatMoney(k.dueToday) },
  { label: 'DUE WITHIN 30 DAYS', dot: 'bg-primary-s500', value: (k) => formatMoney(k.dueWithin30Days) },
  { label: 'OVERDUE INVOICE', dot: 'bg-primary-s500', value: (k) => formatMoney(k.overdueInvoice) },
  { label: 'AVERAGE NO. OF DAYS FOR GETTING PAID', dot: 'bg-primary-s500', value: (k) => `${k.avgDaysToPay} Days` },
];

export function InvoiceKpiCards() {
  const { data, isLoading } = useInvoiceKpis();

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {CARDS.map((c) => (
        <div key={c.label} className="rounded-2xl border border-smoke bg-neutral-white p-5">
          <div className="flex items-center gap-2">
            <span className={`h-2 w-2 rounded-full ${c.dot}`} />
            <span className="text-xs font-medium tracking-wide text-lightGray">{c.label}</span>
          </div>
          {isLoading || !data ? (
            <Skeleton className="mt-2 h-6 w-24" />
          ) : (
            <p className="mt-2 text-xl font-semibold text-black">{c.value(data)}</p>
          )}
        </div>
      ))}
    </div>
  );
}
